import ProjectService from "@/services/project.service.js"
const axios = require('axios').default
import { BASE_VIREED } from './base-url'
import { BASE_URL, WS_VIREED } from './base-url'

//let Pservice = new ProjectService();

let mSocket = null;
var base_vireed = BASE_VIREED;
var base = BASE_URL;
var defaultSocketUrl = WS_VIREED;


export default class vireedAnnotationService {

    reloadCollapse = function (self) {
        if ((self.expand === 1)) {
            document.getElementsByClassName("vac-marker").forEach((marker) => {
                marker.classList.add("expanded");
            });
        } else {
            document.getElementsByClassName("vac-marker").forEach((marker) => {
                try {
                    marker.classList.remove("expanded");
                } catch (ignored) {
                    ""
                }
            });
        }

    };

    selectAnnotation = function (self, ann) {
        self.player.currentTime(ann.range.start);
    };

    reloadVisible = function (pseudo, selected) {
        const checked = selected.includes(pseudo);
        const shapes = document.getElementsByClassName(`${pseudo}-shape`);
        if (checked) {
            shapes.forEach((shape) => {
                if (shape.classList.contains("d-none")) shape.classList.remove("d-none");
            });
        } else {
            shapes.forEach((shape) => {
                shape.classList.add("d-none");
            });
        }
    }

    hoverAnnotation = function (self, ann, leave) {
        let shape = document.getElementsByClassName(ann.id + "-shape");
        if (shape.item(0)) {
            if (leave) {
                shape.item(0).style.borderWidth = "2px";
                shape.item(0).style.borderStyle = "dotted";
                shape.item(0).innerHTML = "";
                shape.item(0).style.opacity = .5;
                if (ann.commentList)
                    shape.item(0).innerHTML = `<div class="innerComment">${ann.commentList.comments[0].body}</div>`;
                else if (ann.comments)
                    shape.item(0).innerHTML = `<div class="innerComment">${ann.comments[0].body}</div>`;

            } else {
                shape.item(0).style.borderWidth = "2px";
                shape.item(0).style.borderStyle = "solid";
                shape.item(0).style.opacity = .75;
                if (ann.commentList)
                    shape.item(0).innerHTML = `<div class="innerComment">${ann.commentList.comments[0].body}</div>`;
                else if (ann.comments)
                    shape.item(0).innerHTML = `<div class="innerComment">${ann.comments[0].body}</div>`;

            }
        }
    };

    hideAnnotation = function (self, annId) {
        let annShape = document.getElementsByClassName(`${annId}-shape`).item(0);
        if (self.hiddenAnnotations.includes(annId)) {
            self.hiddenAnnotations.splice(self.hiddenAnnotations.indexOf(annId), 1);
            if (annShape) annShape.classList.remove("d-none");
        } else {
            self.hiddenAnnotations.push(annId);
            if (annShape) annShape.classList.add("d-none");
        }
    };

    deleteAnnotation = function (self, annId) {
        self.plugin.fire('destroyAnnotation', { id: annId });
    };

    deleteComment = function (self, commId) {
        self.plugin.fire('destroyComment', { id: commId });
    };

    answerComment = function (annId) {
        document.getElementById("btn-" + annId).classList.add("d-none");
        document.getElementById(annId).classList.remove("d-none");
        document.getElementById("text-" + annId).focus();
    };

    hideCommentSection = function (annId) {
        document.getElementById("btn-" + annId).classList.remove("d-none");
        document.getElementById(annId).classList.add("d-none");
        document.getElementById("text-" + annId).value = "";
        document.getElementById("text-" + annId).dispatchEvent(new Event('input'));
    };

    sendComment = function (self, annId) {
        if (document.getElementById("text-" + annId).value !== "") {
            self.plugin.fire('newComment', { annotationId: annId, body: document.getElementById("text-" + annId).value });
            self.hideCommentSection(annId)
        }
    };

    addAnnotation = function (self) {
        if (self.annValue !== "") {
            self.plugin.fire('newAnnotation', {
                range: self.plugin.controls.marker.range,
                shape: self.plugin.controls.selectableShape.shape,
                commentStr: self.annValue,
            });
            self.$emit("openannot");
            self.annValue = "";
            self.annVisible = false;
        }
    };

    cancelAnnotationMode = function (self) {
        self.annVisible = !self.annVisible;
        self.plugin.fire('cancelAddingAnnotation');
    };

    annotationMode = function (self) {
        if (self.annVisible)
            self.plugin.fire('cancelAddingAnnotation');
        else
            self.plugin.fire('addingAnnotation');

        self.annVisible = !self.annVisible;
    };

    leaveProject = function (token, pseudo, self, Swal, idx) {
        Swal.fire({
            icon: "info",
            title: `Project departure`,
            html:
                "Please confirm your will to leave the project",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: `Leave`,
        }).then((result) => {
            if (result.isConfirmed) {
                let Pservice = new ProjectService()
                Pservice.removeCollaborator(token, self.$route.params.projectId, pseudo)
                    .then((response) => {
                        console.log(response);
                        if (response.status === 200) {
                            mSocket.emit("userDeleted", pseudo);
                            self.$router.push('/vireed');
                        }
                        else {
                            res.json().then((error) => {
                                console.log(error.message);
                            });
                        }
                    })
            }
        });
    };

    deleteUser = function (token, pseudo, self, Swal) {
        Swal.fire({
            title: `Collaborator exclusion`,
            html:
                'Please confirm the exclusion of Collaborator "' + pseudo + '" from this project',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: `Exclude`,
        }).then((result) => {
            if (result.isConfirmed) {
                let Pservice = new ProjectService()
                Pservice.removeCollaborator(token, self.$route.params.projectId, pseudo)
                    .then((response) => {
                        console.log(response);
                        if (response.status === 200) {
                            mSocket.emit("userDeleted", pseudo);
                            self.changeVersion();

                            var idx = self.collabsList.findIndex(collab => collab.pseudo === pseudo)

                            self.collabsList.splice(idx, 1);
                            self.updateUserList();
                            self.$bvModal.hide("modal-username")

                        }
                        else {
                            res.json().then((error) => {
                                console.log(error.message);
                            });
                        }
                    })


                // let url =
                //     "/a/project/" + self.$route.params.projectId + "/user/" + id;
                // fetch(url, {
                //     method: "DELETE",
                // }).then((res) => {
                //     console.log(res.status);
                //     if (res.status === 200) {
                //         mSocket.emit("userDeleted", pseudo);
                //         self.changeVersion();
                //         self.collabsList.splice(idx, 1);
                //         self.collaboratorsListKey++;
                //         console.log("user deleted");
                //     } else {
                //         res.json().then((error) => {
                //             console.log(error.message);
                //         });
                //     }
                // });
            }
        });
    };

    playerReady = function (self, user, token) {
        self.pluginOptions = {
            bindArrowKeys: false,
            meta: {
                //user_id: user.id,
                user_name: user.username,
                token: token
            },
            showControls: false,
            showCommentList: false, // to see comment section
            showFullScreen: true,
            startInAnnotationMode: true,
            showMarkerShapeAndTooltips: true,
        };

        self.plugin = self.player.annotationComments(self.pluginOptions);
        self.plugin.onReady(self.pluginReady);
    };

    pluginReady = function (self, io, Swal) {
        self.annotations = self.plugin.annotationState.annotations;
        self.activeAnnotations = self.plugin.annotationState.activeAnnotationList;
        // initialize socket
        let socket = io(defaultSocketUrl, {
            auth: {
                token: self.pluginOptions.meta.token,
            }
        });
        let token = self.$auth.token()
        self.socket = socket;
        mSocket = socket;
        self.socketReady();
        if (self.roleChanged) {
            socket.emit("role")
        }

        socket.on("connect", () => {
            // indicate the id of your project to the server
            socket.emit("room", self.projectId);
            socket.on("join", (canEdit) => {
                self.canEdit = canEdit;
                // indicate the id of the current version
                socket.emit("version", self.version);
                socket.on("versionNb", (version) => {
                    self.version = version;
                });
                socket.emit("connected", self.pluginOptions.meta.user_name);
            });
            // when the user tries to call another user directly
            let els = document.getElementsByClassName("IndividualBtn");
            Array.prototype.forEach.call(els, function (el) {
                el.addEventListener('click', function () {
                    if (document.getElementById(`${this.id}-connect`).classList.contains("connected")) {
                        let username
                        let url = "/a/user";
                        fetch(url)
                            .then((res) => {
                                if (res.status === 200) {
                                    res.json().then((data) => {
                                        username = data.pseudo;
                                        if (!document.getElementById(`${username}-connect`).classList.contains("inCall")) {
                                            document.getElementById(`${username}-connect`).classList.add("inCall");
                                            socket.emit('individual-call', { sender: username, target: this.id });
                                            Swal.fire({
                                                icon: 'info',
                                                title: `Calling ${this.id} ... `,
                                                timer: 10000,
                                                showConfirmButton: false
                                            });
                                        } else {
                                            Swal.fire({
                                                icon: 'error',
                                                title: `You are already in a call `,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                confirmButtonText: `OK`,
                                            });
                                        }
                                    });
                                }
                            });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: `${this.id} is currenty disconnected`,
                            showConfirmButton: true,
                            confirmButtonText: `OK`,
                        });
                    }
                });
            });
        });

        socket.on("annotations", (annotations) => {
            self.countAnnotationByUser(annotations)
        })

        socket.on("usersAdd", () => {
            self.$emit("userAdds")
        });

        socket.on("teamRemove", () => {
            self.$emit("usersRemove")
        });
        socket.on("teamEdit", () => {
            self.$emit("teamEdit")
        })

        socket.on("checkEdit", (canEdit) => {
            self.canEdit = canEdit;
        });
        socket.on("userDeleted", (pseudo) => {
            if (self.$auth.getMyUser().username == pseudo) {
                Swal.fire({
                    icon: 'info',
                    title: `You have been excluded from the project`,
                    html: 'You will be redirected to the Projects main page',
                    showConfirmButton: true,
                    showCancelButton: false,
                    timerProgressBar: true,
                    confirmButtonText: `OK`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        self.$router.push('/vireed');
                    }
                });
            }
            else {
                self.$emit("usersRemove")
            }

        });
        socket.on("userJoined", (pseudo) => {
            let route = self.$router.currentRoute;
            setTimeout(() => {
                if (route != self.$router.currentRoute) return;
                try {
                    self.$emit("userJoined", pseudo)
                    //document.getElementById(`${pseudo}-connect`).classList.add("connected");
                } catch (e) {
                    console.log(e)
                    /**Swal.fire({
                        icon: 'info',
                        title: `${pseudo} has joined the project`,
                        html: 'Click OK to reload the page and see this user\'s annotations',
                        showConfirmButton: true,
                        showCancelButton: true,
                        timerProgressBar: true,
                        confirmButtonText: `OK`,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            self.$router.go(self.$router.currentRoute);
                        }
                    });*/
                }
            }, 1000);
        });
        socket.on("userLeft", (pseudo) => {
            try {
                self.$emit("userLeft", pseudo)
                //document.getElementById(`${pseudo}-connect`).classList.remove("connected");
            } catch (e) {
                console.log(e);
            }
        });
        socket.on("disconnect", () => {
            console.log("You have been disconnected");
        });
        socket.on("projectDeleted", (id) => {
            if (self.$route.params.projectId != id) return;
            Swal.fire({
                icon: 'info',
                title: `This project was deleted`,
                html: 'You will be redirected to the Projects main page',
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: `OK`,
            }).then(() => {
                self.$router.push("/vireed");
            });
        });
        socket.on("role", () => {
            self.$emit("role");
            /**
            Swal.fire({
                icon: 'info',
                title: `Some collaborators roles have changed`,
                html: 'Click OK to reload the page and see the modifications',
                showConfirmButton: true,
                showCancelButton: true,
                timerProgressBar: true,
                confirmButtonText: `OK`,
            }).then((result) => {
                if (result.isConfirmed) {                    
                    self.$router.go(self.$router.currentRoute);
                }
            });**/
        });
        socket.on("versionDeleted", (data) => {
            console.log("version", self.version)
            console.log("version delete", data.version)
            if (self.$route.params.projectId != data.id || (self.$route.params.projectId == data.id && self.version != data.version)) return;
            Swal.fire({
                icon: 'info',
                title: `This version was deleted`,
                html: 'You will be redirected to the latest version',
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: `OK`,
            }).then((result) => {
                if (result.isConfirmed) {
                    let Pservice = new ProjectService();
                    Pservice.getLastestVersion(token, self.$route.params.projectId)
                        .then(Lastversion => {
                            if(self.version != Lastversion.data.number)
                            {
                                self.$router.push(`/project/${self.$route.params.projectId}/${Lastversion.data.number}`);
                                self.$emit('version');
                            }
                        }).catch((error) => {
                            console.log(error);
                        })
                }
            });
        });

        socket.on("newVersion", () => {
            //console.log(self);
        })
        // when an annotation is received from the socket, add it
        socket.on("annotation", (data) => {

            if (data.version !== self.version || self.version === "-1") {
                return;
            }
            if (self.plugin.annotationState.findAnnotation(data.annotation.id)) {
                // if annotation exists, update comments
                data.annotation.comments.forEach((comm) => {
                    if (!self.plugin.annotationState.findComment(comm.id)) {
                        self.plugin.fire("newExtComment", {
                            annotationId: data.annotation.id,
                            body: comm,
                        });
                    }
                });
            } else {
                // add a new annotation that is not the user's one
                self.plugin.fire("newExtAnnotation", data.annotation);
                self.activeAnnotations = self.plugin.annotationState.activeAnnotationList;
                self.annotations = self.plugin.annotationState.annotations;
                this.reloadCollapse(self);
            }
        });
        // when another user destroy an annotation, remove it too
        socket.on("destroyAnnotation", (data) => {
            if (self.plugin.annotationState.findAnnotation(data.id)) {
                // if annotation exists, remove it
                self.plugin.fire('destroyExtAnnotation', { id: data.id });
            }
        });

        // when another user destroy a comment, remove it too
        socket.on("destroyComment", (commentId) => {
            if (self.plugin.annotationState.findComment(commentId)) {
                // if comment exists, remove it
                self.plugin.fire('destroyExtComment', { id: commentId });
            }
        })

        socket.on("play", (currentTime, version) => {
            if (version != self.version || version === -1) return;

            if (self.isControlled) {
                self.player.currentTime(currentTime);
                self.player.play();
                self.toastVideo(`${self.controlledBy} launch the video`)
            }

        })

        socket.on("pause", (currentTime, version) => {
            if (version != self.version || version === -1) return;

            if (self.isControlled) {
                self.player.pause();
                self.player.currentTime(currentTime)
                self.toastVideo(`${self.controlledBy} stop the video`)
            }

        })

        socket.on("seeked", (currentTime, version) => {
            if (version != self.version || version === -1) return;
            if (self.isControlled) {
                self.player.currentTime(currentTime);
                self.toastVideo(`${self.controlledBy} jump to ${currentTime}`)
            }
        })

        socket.on("takeControl", (username, version, currentTime) => {
            if (version != self.version || version === -1) return;

            Swal.fire({
                icon: 'info',
                title: `Delegate video's control`,
                html: `${username} wants to take control of the video  `,
                showConfirmButton: true,
                showCancelButton: true,
                timerProgressBar: true,
                confirmButtonText: `OK`,
            }).then((result) => {
                if (result.isConfirmed) {
                    self.isControlled = true;
                    self.controlledBy = username;
                    //On désactive les controles et on met la vidéo isControlled à true et controlledBy à username
                    //Attantion, bien vérifié que les versions soient les mêmes
                    self.player.controls(false);
                    self.player.pause();
                    self.player.currentTime(currentTime);
                }
            });
        })

        socket.on("releaseControl", (username, version) => {
            if (version != self.version || version === -1) return;

            if (self.controlledBy === username) {
                self.isControlled = false;
                self.controlledBy = "";
                self.player.controls(true)
                self.toastVideo(`${username} stop to control the video player `)
            }
        })

        socket.on("projectInfoUpdated", () =>{
            self.$emit("projectInfoUpdated")
        })
        // when the user add an annotation or comment
        self.plugin.registerListener("onStateChanged", (event) => {

            //On envoie une requête pour mettre à jour
            return new Promise((done, reject) => {
                // get latest added annotation or comment
                let annotation = event.detail.data.filter((obj) => {
                    return obj.id === event.detail.id;
                })[0];
                // send it to the room/project
                let data = { room: self.projectId, annotation: annotation, version: self.version };
                socket.emit("annotation", data);
                this.reloadCollapse(self);

                var instance = {
                    baseURL: base + '/api/projects/timestamp/' + self.projectId,
                    method: 'put',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + self.$auth.token()
                    },
                };
                axios(instance).then((response) => {
                    done(response.data);
                }).catch((error) => {
                    reject(error);
                })
            })
        });
        // when the user destroy an annotation
        self.plugin.registerListener('annotationDeleted', (event) => {

            return new Promise((done, reject) => {

                let annotationId = event.detail;
                let data = { room: self.projectId, annotationId: annotationId };
                socket.emit("destroyAnnotation", data);

                var instance = {
                    baseURL: base + '/api/projects/timestamp/' + self.projectId,
                    method: 'put',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + self.$auth.token()
                    },
                };
                axios(instance).then((response) => {
                    done(response.data);
                }).catch((error) => {
                    reject(error);
                })
            })
        });
        // when the user destroy a comment
        self.plugin.registerListener('commentDeleted', (event) => {


            return new Promise((done, reject) => {

                let commData = event.detail;
                let data = { room: self.projectId, commentId: commData.commId, annotationId: commData.annId };
                socket.emit("destroyComment", data);

                var instance = {
                    baseURL: base + '/api/projects/timestamp/' + self.projectId,
                    method: 'put',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + self.$auth.token()
                    },
                };
                axios(instance).then((response) => {
                    done(response.data);
                }).catch((error) => {
                    reject(error);
                })
            })
        });
        // if an annotation is opened but is in hidden list, don't show it
        self.plugin.registerListener('annotationOpened', (event) => {
            const ann = event.detail.annotation;
            const annId = ann.id;
            const shape = document.getElementsByClassName(`${annId}-shape`).item(0);
            if (self.hiddenAnnotations.includes(annId) || !self.selectedPeople.includes(ann.comments[0].meta.user_name)) {
                shape.classList.add("d-none");
            }
            if (shape) {
                shape.addEventListener("mouseenter", function () {
                    //hoverAnnotation(null, ann, false)
                    let shape = document.getElementsByClassName(ann.id + "-shape");
                    if (shape.item(0)) {
                        shape.item(0).style.borderWidth = "3px";
                        shape.item(0).style.borderStyle = "solid";
                        shape.item(0).style.opacity = .75;
                        if (ann.commentList)
                            shape.item(0).innerHTML = `<div class="innerComment">${ann.commentList.comments[0].body}</div>`;
                        else if (ann.comments)
                            shape.item(0).innerHTML = `<div class="innerComment">${ann.comments[0].body}</div>`;

                    }
                });
                shape.addEventListener("mouseleave", function () {
                    //hoverAnnotation(null, ann, true)
                    let shape = document.getElementsByClassName(ann.id + "-shape");
                    if (shape.item(0)) {
                        shape.item(0).style.borderWidth = "1.5px";
                        shape.item(0).style.borderStyle = "dotted";
                        shape.item(0).innerHTML = "";
                        shape.item(0).style.opacity = .5;
                    }
                });
            }
            setTimeout(() => {
                let active = document.getElementsByClassName("activeComment");
                let i = 0;
                while (active.item(i)) {
                    active.item(i).scrollIntoView({ behavior: "smooth", block: "center" });
                    i++;
                }
            }, 50);
        });

        self.plugin.registerListener('addingAnnotationDataChanged', (event) => {
            
            if(event.detail.range != undefined)
            {
                self.rangeCurrentAnnotation = {
                    start:0,
                    end:0
                }
                
                self.rangeCurrentAnnotation.start = event.detail.range.start;
                self.rangeCurrentAnnotation.end = event.detail.range.end
            }
        });

        // update active annotations on timeupdate
        self.player.on('timeupdate', () => {
            self.activeAnnotations = self.plugin.annotationState.activeAnnotationList;
        });

        self.player.muted(true);
        self.player.play();
        self.player.pause();
        self.player.muted(false);
    };

    noPlugin = function (self, io, Swal) {
        // initialize socket
        let socket = io(defaultSocketUrl);

        let token = self.$auth.token()
        self.socket = socket;
        mSocket = socket;
        self.socketReady();
        if (self.roleChanged) {
            socket.emit("role");
        }

        socket.on("connect", () => {
            // indicate the id of your project to the server
            socket.emit("room", self.projectId);
            socket.on("join", (canEdit) => {
                self.canEdit = canEdit;
                // indicate the id of the current version
                socket.emit("version", self.version);
                socket.on("versionNb", (version) => {
                    self.version = version;
                });
                socket.emit("connected", self.$auth.getMyUser().username);

            });
        });

        socket.on("usersAdd", () => {
            self.$emit("userAdds")
        });

        socket.on("teamRemove", () => {
            self.$emit("usersRemove")
        });
        socket.on("teamEdit", () => {
            self.$emit("teamEdit")
        })

        //le plugin n'est pas initialisé donc on ne fait rien
        socket.on("checkEdit", (canEdit) => {
            self.canEdit = false;
        });

        socket.on("userDeleted", (pseudo) => {
            if (self.$auth.getMyUser().username == pseudo) {
                Swal.fire({
                    icon: 'info',
                    title: `You have been excluded from the project`,
                    html: 'You will be redirected to the Projects main page',
                    showConfirmButton: true,
                    showCancelButton: false,
                    timerProgressBar: true,
                    confirmButtonText: `OK`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        self.$router.push('/vireed');
                    }
                });
            }
            else {
                self.$emit("usersRemove")
            }

        });

        socket.on("userJoined", (pseudo) => {
            console.log(`${pseudo} joined`);
            let route = self.$router.currentRoute;
            setTimeout(() => {
                if (route != self.$router.currentRoute) return;
                try {
                    self.$emit("userJoined", pseudo)
                    //document.getElementById(`${pseudo}-connect`).classList.add("connected");
                } catch (e) {
                    console.log(`user ${pseudo} joined`)
                    /**Swal.fire({
                        icon: 'info',
                        title: `${pseudo} has joined the project`,
                        html: 'Click OK to reload the page and see this user\'s annotations',
                        showConfirmButton: true,
                        showCancelButton: true,
                        timerProgressBar: true,
                        confirmButtonText: `OK`,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            self.$router.go(self.$router.currentRoute);
                        }
                    });*/
                }
            }, 1000);
        });

        socket.on("userLeft", (pseudo) => {
            try {
                self.$emit("userLeft", pseudo)
                //document.getElementById(`${pseudo}-connect`).classList.remove("connected");
            } catch (e) {
                console.log(e);
            }
        });

        socket.on("disconnect", () => {
            console.log("You have been disconnected");
        });

        socket.on("projectDeleted", (id) => {
            if (self.$route.params.projectId != id) return;
            Swal.fire({
                icon: 'info',
                title: `This project was deleted`,
                html: 'You will be redirected to the Projects main page',
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: `OK`,
            }).then(() => {
                self.$router.push("/vireed");
            });
        });

        socket.on("role", () => {
            self.$emit("role");
            /**
            Swal.fire({
                icon: 'info',
                title: `Some collaborators roles have changed`,
                html: 'Click OK to reload the page and see the modifications',
                showConfirmButton: true,
                showCancelButton: true,
                timerProgressBar: true,
                confirmButtonText: `OK`,
            }).then((result) => {
                if (result.isConfirmed) {                    
                    self.$router.go(self.$router.currentRoute);
                }
            });**/
        });

        socket.on("versionDeleted", (data) => {
            console.log("version", self.version)
            console.log("version delete", data.version)

            if (self.$route.params.projectId != data.id || (self.$route.params.projectId == data.id && self.version != data.version)) return;
            Swal.fire({
                icon: 'info',
                title: `This version was deleted`,
                html: 'You will be redirected to the latest version',
                showConfirmButton: true,
                showCancelButton: false,
                confirmButtonText: `OK`,
            }).then((result) => {
                if (result.isConfirmed) {
                    let Pservice = new ProjectService();
                    Pservice.getLastestVersion(token, self.$route.params.projectId)
                        .then(Lastversion => {
                            self.$router.push(`/project/${self.$route.params.projectId}/${Lastversion.data.number}`);
                            self.$emit('version');

                        }).catch((error) => {
                            console.log(error);
                        })
                }
            });
        });

        socket.on("newVersion", () => {
        });

        socket.on("projectInfoUpdated", () =>{
            self.$emit("projectInfoUpdated")
        })
    };

    deleteProject = function (self, token, socket) {
        if (!socket) {
            console.log("pas de socket")
            return;
        }

        self.dialog = false;
        let url = base_vireed + "/delete/" + self.$route.params.projectId;
        var dataToSend = { token: token };
        dataToSend = JSON.stringify(dataToSend);

        fetch(url, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Basic ' + token
            },
            data: dataToSend,
            body: dataToSend,

        }).then((res) => {
            if (res.status === 200) {
                self.standby = false;
                socket.emit("projectDeleted", self.$route.params.projectId);
                self.$router.push("/vireed/");
            }
        });
    }

    deleteVersion = function (self, version, token, socket) {

        return new Promise((done, reject) => {

            self.dialog = false;

            let url = base_vireed + `/deleteVersion/${self.$route.params.projectId}/${version}/`;
            var dataToSend = { token: token };
            dataToSend = JSON.stringify(dataToSend);

            var instance = {
                baseURL: url,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: dataToSend,
                body: dataToSend,
            };
            axios(instance).then((response) => {
                console.log(response);
                if (response.status === 200) {
                    let Pservice = new ProjectService();
                    Pservice.getLastestVersion(token, self.$route.params.projectId)
                        .then(Lastversion => {
                            let data = { id: self.$route.params.projectId, version: version };
                            socket.emit("versionDeleted", data);
                            
                            if (version == self.$route.params.version) {
                                self.$router.push(`/vireed/${self.$route.params.projectId}/${Lastversion.data.number}`);
                            }
                            self.$emit('version-changed');

                        }).catch((error) => {
                            console.log(error);
                        })
                    done(response.data);
                }
            }).catch((error) => {
                reject(error);
            })
        });
    }

    changeRole = function (self, token, username, newRole) {
        let Pservice = new ProjectService()
        Pservice.updateRoleUser(token, self.$route.params.projectId, username, newRole)
            .then((response) => {
                self.roleChanged = true;
                self.reloadProjectUser()
                self.$bvModal.hide('modal-change-role')
                self.$socket.emit("role")

                //Si l'utilisateur à lui même à changer son rôle on reload la page pour rafraichir ses droits
                if (username === self.$auth.getMyUser().username)
                    self.videoKey++;

            }).catch((error) => {
                console.error(error)
            })
    }

    beforeDestroyExecutedMethod = function (self) {
        if (self.player) {
            self.player.dispose();
        }
        if(self.socket != undefined)
            self.socket.disconnect()
    }

    getAnnotationNumberByUser = function (self) {
        let url = base_vireed + "/annotations/" + self.projectId + "/" + self.projectVersion + "/" + self.collabsList[0].pseudo;

        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((res) => {
            if (res.status === 200) {
                self.standby = false;
                socket.emit("projectDeleted", self.$route.params.projectId);
                self.$router.push("/vireed/");
            }
        });
    }

}



// module.exports = {
//     reloadCollapse,
//     selectAnnotation,
//     reloadVisible,
//     hoverAnnotation,
//     hideAnnotation,
//     deleteAnnotation,
//     deleteComment,
//     answerComment,
//     hideCommentSection,
//     sendComment,
//     addAnnotation,
//     cancelAnnotationMode,
//     annotationMode,
//     playerReady,
//     pluginReady,
//     deleteProject,
//     deleteVersion,
//     beforeDestroyExecutedMethod,
//     deleteUser
// }
